import { render, staticRenderFns } from "./detailEvento.vue?vue&type=template&id=63fea5ef"
import script from "./detailEvento.vue?vue&type=script&lang=js"
export * from "./detailEvento.vue?vue&type=script&lang=js"
import style0 from "./detailEvento.vue?vue&type=style&index=0&id=63fea5ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports